const ageRatings = [
  { acronym: 'L', description: 'L', color: '#3D8940', priority: 2 },
  { acronym: 'AL', description: 'AL', color: '#3D8940', priority: 1 },
  { acronym: '6', description: '6', color: '#e43493', priority: 4 },
  { acronym: 'A6', description: 'A6', color: '#e43493', priority: 3 },
  { acronym: '10', description: '10', color: '#3274B0', priority: 6 },
  { acronym: 'A10', description: 'A10', color: '#3274B0', priority: 5 },
  { acronym: '12', description: '12', color: '#EAC743', priority: 8 },
  { acronym: 'A12', description: 'A12', color: '#EAC743', priority: 7 },
  { acronym: '14', description: '14', color: '#FF6501', priority: 10 },
  { acronym: 'A14', description: 'A14', color: '#FF6501', priority: 9 },
  { acronym: '16', description: '16', color: '#C02E26', priority: 12 },
  { acronym: 'A16', description: 'A16', color: '#C02E26', priority: 11 },
  { acronym: '18', description: '18', color: '#060606', priority: 14 },
  { acronym: 'A18', description: 'A18', color: '#060606', priority: 13 },
];
export default ageRatings;
